"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTrackOrderWithPositionId = exports.useTrackOrderMap = exports.usePositionAssociateTPSLOrder = exports.refreshPositionTPSL = exports.getTrackOrderObservable = exports.batchGetPositionTPSL = exports.getAssociateTPSLOrderObserver = exports.sortTPSLOrders = exports.sortOrdersByTriggerPriceAsc = exports.sortOrdersByTriggerPriceDesc = void 0;
const react_1 = require("react");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../../../interface");
const rx_1 = require("./rx");
/**按触发价格降序排序 */
const sortOrdersByTriggerPriceDesc = (o1, o2) => new trade_utils_lib_1.SafeDecimal(o2.trigger_price).sub(o1.trigger_price).toNumber();
exports.sortOrdersByTriggerPriceDesc = sortOrdersByTriggerPriceDesc;
/**按触发价格升序排序 */
const sortOrdersByTriggerPriceAsc = (o1, o2) => new trade_utils_lib_1.SafeDecimal(o1.trigger_price).sub(o2.trigger_price).toNumber();
exports.sortOrdersByTriggerPriceAsc = sortOrdersByTriggerPriceAsc;
/**
 * 做多
 *
 * 止盈：获取触发价格最低的订单，止损：获取价格最高的订单
 *
 * 做空
 *
 * 止盈：获取触发价格最高的订单，止损：获取价格最低的订单
 *
 */
function sortTPSLOrders(mode, orderList) {
    if (!(orderList === null || orderList === void 0 ? void 0 : orderList.length)) {
        return [];
    }
    const side = orderList[0].position_side;
    const compFn = (() => {
        if (side === interface_1.FuturePositionSide.LONG) {
            return mode === "tp" ? exports.sortOrdersByTriggerPriceAsc : exports.sortOrdersByTriggerPriceDesc;
        }
        return mode === "tp" ? exports.sortOrdersByTriggerPriceDesc : exports.sortOrdersByTriggerPriceAsc;
    })();
    return (orderList || []).slice().sort(compFn);
}
exports.sortTPSLOrders = sortTPSLOrders;
/**
 * 获取某个仓位关联的止盈止损
 * @param positionId 仓位id
 */
function getAssociateTPSLOrderObserver(positionId) {
    return rx_1.positionConsumeSubject.pipe((0, operators_1.map)(() => {
        const { tpOrderMap, slOrderMap, isLoading } = rx_1.PositionTPSLStore;
        const tpOrderList = sortTPSLOrders("tp", tpOrderMap.get(positionId));
        const slOrderList = sortTPSLOrders("sl", slOrderMap.get(positionId));
        return {
            allTpOrders: tpOrderList,
            allSlOrders: slOrderList,
            tpOrder: tpOrderList[0],
            slOrder: slOrderList[0],
            loading: isLoading(),
        };
    }));
}
exports.getAssociateTPSLOrderObserver = getAssociateTPSLOrderObserver;
function batchGetPositionTPSL(positionIds) {
    return rx_1.positionConsumeSubject.pipe((0, operators_1.map)(() => {
        const { tpOrderMap, slOrderMap, isLoading } = rx_1.PositionTPSLStore;
        let tpOrderList = [];
        let slOrderList = [];
        positionIds.forEach((id) => {
            tpOrderList = tpOrderList.concat(tpOrderMap.get(id) || []);
            slOrderList = slOrderList.concat(slOrderMap.get(id) || []);
        });
        return {
            allTpOrders: tpOrderList,
            allSlOrders: slOrderList,
            loading: isLoading(),
        };
    }));
}
exports.batchGetPositionTPSL = batchGetPositionTPSL;
/**获取追踪出场单相关的数据 */
function getTrackOrderObservable() {
    return rx_1.positionConsumeSubject.pipe((0, operators_1.map)(() => {
        const { getTrackMap } = rx_1.PositionTPSLStore;
        return getTrackMap();
    }));
}
exports.getTrackOrderObservable = getTrackOrderObservable;
/**刷新仓位关联的条件单 */
function refreshPositionTPSL() {
    (0, rx_1.dispatchPositionTpSlEvent)({ event: "refresh", ids: [] });
}
exports.refreshPositionTPSL = refreshPositionTPSL;
/**
 * 通过Position id获取当前仓位关联的止盈止损，可以同时存在多对止盈止损
 * @param positionId 需要查询的仓位的id
 * @param active 指定是否激活监听
 * @param autoRefresh 当重新激活之后，是否通过接口获取最新的数据，默认为false
 */
function usePositionAssociateTPSLOrder(positionId) {
    const [value, setValue] = (0, react_1.useState)({ loading: true });
    const isInit = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        const sub = getAssociateTPSLOrderObserver(positionId).subscribe({
            next: (data) => {
                if (!data.loading) {
                    isInit.current = true;
                }
                setValue(data);
            },
            error: () => { }
        });
        return () => {
            sub.unsubscribe();
        };
    }, [positionId]);
    return value;
}
exports.usePositionAssociateTPSLOrder = usePositionAssociateTPSLOrder;
/**获取仓位关联的追踪出场的map */
function useTrackOrderMap(isActive = false) {
    const [trackOrderMap, setTrackMap] = (0, react_1.useState)(new Map());
    (0, react_1.useEffect)(() => {
        if (!isActive) {
            return;
        }
        const sub = getTrackOrderObservable().subscribe({
            next: (data) => {
                setTrackMap(data);
            },
            error: () => { }
        });
        return () => {
            sub.unsubscribe();
        };
    }, [isActive]);
    return { trackOrderMap, refresh: refreshPositionTPSL };
}
exports.useTrackOrderMap = useTrackOrderMap;
/**获取仓位关联的追踪出场单 */
function useTrackOrderWithPositionId(positionId, isActive = false) {
    const { trackOrderMap } = useTrackOrderMap(isActive);
    return trackOrderMap.get(positionId);
}
exports.useTrackOrderWithPositionId = useTrackOrderWithPositionId;
